import { loadingSelector } from 'reduxModules/app/selectors'
import { createStructuredSelector } from 'reselect'

export default createStructuredSelector({ loading: loadingSelector })
